import { doShowSnackbar } from 'actions/snackbar'
import grooveAPI from 'api/groove'

import { oauthTokenSelector } from 'selectors/app'

import {
  UPDATE_INTEGRATION_CREDENTIALS_ERROR,
  UPDATE_INTEGRATION_CREDENTIALS_RESPONSE,
  UPDATE_INTEGRATION_CREDENTIALS_REQUEST,
} from '../types'

export default function doSaveIntegrationCredentials(provider, values) {
  return (dispatch, getState) => {
    const token = oauthTokenSelector(getState())
    dispatch({
      meta: { provider },
      payload: values,
      type: UPDATE_INTEGRATION_CREDENTIALS_REQUEST,
    })
    grooveAPI
      .put(
        token,
        `v1/integrations/${provider}`,
        null,
        JSON.stringify({
          integration: values,
        })
      )
      .then(({ json: { integration: payload } }) => {
        dispatch({
          meta: { integrationId: payload.id, provider },
          payload,
          type: UPDATE_INTEGRATION_CREDENTIALS_RESPONSE,
        })
      })
      .catch(error => {
        dispatch(doShowSnackbar(`Integration settings failed to save`))
        dispatch({
          error: true,
          meta: { provider },
          type: UPDATE_INTEGRATION_CREDENTIALS_ERROR,
          payload: error,
        })
      })
  }
}
